module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5n7cjV/tc-custom/9781633410008.jpg?1729938046636",
      "alt": "This image is the cover for the book H.P. Lovecraft & the Black Magickal Tradition"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("H.P. Lovecraft & the Black Magickal Tradition\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Lovecraft scholar presents a penetrating study of the author’s life, work, and connections to modern occultism.")]), _c('br'), _c('br'), _vm._v("Many practicing occultists have speculated that H. P. Lovecraft possessed in-depth knowledge of black magick. Yet literary scholars maintain the renowned horror writer was simply a master of his craft, and that the enduring power of his work is purely the result of his rich imagination."), _c('br'), _c('br'), _vm._v("In "), _c('i', [_vm._v("H.P. Lovecraft & the Black Magical Tradition")]), _vm._v(", John L. Steadman examines the considerable overlap between the author’s fictions and true occultism—and consider whether Lovecraft was a practitioner of the dark arts himself."), _c('br'), _c('br'), _vm._v("Weaving Lovecraft’s biography together with literary criticism and modern magickal systems, Steadman demonstrates that Lovecraft’s works—specifically his Cthulhu Mythos and his creation of the Necronomicon—represent the basis for a legitimate magickal system.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John L. Steadman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John L. Steadman is a scholar of H. P. Lovecraft and western occultism and has been a magickal practitioner for more than thirty years. He is currently a college English professor at Olivet College in Michigan. Visit him at www.johnlsteadman.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Weiser Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0